import React from 'react';
import '../css/Footer.css'

const Footer = () => {
  return (
    <footer className="custom-bg text-white text-center py-3">
      &copy; {new Date().getFullYear()} FarmHouse Media & Consulting
    </footer>
  );
};

export default Footer;
